import {
  ADD_STAFF_CI,
  ADD_STAFF_EDI,
  ADD_STAFF_GI,
  ADD_STAFF_PI,
  ADD_STAFF_WI,
  APP_STATUS,
  DEACTIVATE_USER,
  MAKE_STAFF_USER,
  REMOVE_STAFF_EDI,
  STAFF_LIST,
  ROLES_URL,
  STATE_URL,
  UPDATE_STAFF_CI,
  UPDATE_STAFF_EDI,
  UPDATE_STAFF_EMI,
  UPDATE_STAFF_GI,
  UPDATE_STAFF_NKI,
  UPDATE_STAFF_PI,
  UPDATE_STAFF_WI,
  ACTIVATE_STAFF,
  DEACTIVATE_STAFF,
} from "../../../api/constant";
import { getObjectEntries } from "../../../utils/validators/validators";
import axiosPrivate from "./../../../api/axiosPrivate";
import {
  ADD_STAFF_EMI,
  ADD_STAFF_NKI,
  STAFF_INFORMATION,
} from "./../../../api/constant";

// Fetch all states
const fetchAllStates = async () => {
  const response = await axiosPrivate.get(STATE_URL);
  return response.data;
};

// Fetch all staffs
const getAllStaffs = async ({ pageNumber, search }) => {
  const response = await axiosPrivate.get(
    `${STAFF_LIST}?page=${pageNumber}&search=${search}`
  );
  return response.data;
};

// Fetch all roles
const getAllRoles = async () => {
  const response = await axiosPrivate.get(ROLES_URL);
  return response.data;
};

// Fetch app status
const getAppStatus = async (APP_ID) => {
  const response = await axiosPrivate.get(`${APP_STATUS}/${APP_ID}`);
  return response.data;
};

// Fetch staff information
const getStaffInformation = async (staff_id) => {
  const response = await axiosPrivate.get(`${STAFF_INFORMATION}/${staff_id}`);
  return response.data;
};

// Add staff personal information
const addStaffPersonalInfo = async (personalInfo) => {
  let formdata = { ...personalInfo };
  delete formdata["temp_url"];
  const fd = new FormData();
  let data = getObjectEntries(formdata);
  data.forEach(([key, value]) => {
    fd.append(key, value);
  });
  // fd.append
  const response = await axiosPrivate.post(ADD_STAFF_PI, fd);
  return response.data;
};
// Add staff contact information
const addStaffContactInfo = async (contactInfo) => {
  const response = await axiosPrivate.post(ADD_STAFF_CI, contactInfo);
  return response.data;
};
// Add staff educational information
const addStaffEducationalInfo = async (educationalInfo) => {
  let formdata = { ...educationalInfo };
  delete formdata["temp_url"];
  const fd = new FormData();
  let data = getObjectEntries(formdata);
  data.forEach(([key, value]) => {
    fd.append(key, value);
  });
  // fd.append
  const response = await axiosPrivate.post(ADD_STAFF_EDI, fd);
  return response.data;
};
// Remove staff educational information
const removeStaffEducationalInfo = async (recordID) => {
  const response = await axiosPrivate.get(`${REMOVE_STAFF_EDI}/${recordID}`);
  return response.data;
};
// Add staff employment information
const addStaffEmploymentInfo = async (employmentInfo) => {
  const response = await axiosPrivate.post(ADD_STAFF_EMI, employmentInfo);
  return response.data;
};
// Add staff guarantor information
const addStaffGuarantorInfo = async (guarantorInfo) => {
  let formdata = { ...guarantorInfo };
  delete formdata["temp_url"];
  const fd = new FormData();
  let data = getObjectEntries(formdata);
  data.forEach(([key, value]) => {
    fd.append(key, value);
  });
  // fd.append
  const response = await axiosPrivate.post(ADD_STAFF_GI, fd);
  return response.data;
};
// Add staff work experience
const addStaffWorkExperience = async (workExperience) => {
  const response = await axiosPrivate.post(ADD_STAFF_WI, workExperience);
  return response.data;
};
// Add staff next of kin information
const addStaffNextOfKinInfo = async (nextOfKinInfo) => {
  const response = await axiosPrivate.post(ADD_STAFF_NKI, nextOfKinInfo);
  return response.data;
};

// Make staff a user
const makeStaffUser = async (data) => {
  const response = await axiosPrivate.post(MAKE_STAFF_USER, data);
  return response.data;
};

// ==========================
// UPDATE STAFF INFORMATION
// ==========================
const updateStaffPersonalInfo = async (personalInfo) => {
  let formdata = { ...personalInfo };
  delete formdata["temp_url"];
  const fd = new FormData();
  // fd.append('_method', 'POST')
  let data = getObjectEntries(formdata);
  data.forEach(([key, value]) => {
    fd.append(key, value);
  });
  // // fd.append
  const response = await axiosPrivate.post(
    `${UPDATE_STAFF_PI}/${personalInfo.id}`,
    fd
  );
  return response.data;
};
// Update staff contact Information
const updateStaffContactInfo = async (contactInfo) => {
  const response = await axiosPrivate.post(
    `${UPDATE_STAFF_CI}/${contactInfo.id}`,
    contactInfo
  );
  return response.data;
};
// Update staff educational Information
const updateStaffEducationalInfo = async (educationalInfo) => {
  let formdata = { ...educationalInfo };
  delete formdata["temp_url"];
  const fd = new FormData();
  // // fd.append('_method', 'POST')
  let data = getObjectEntries(formdata);
  data.forEach(([key, value]) => {
    fd.append(key, value);
  });
  const response = await axiosPrivate.post(
    `${UPDATE_STAFF_EDI}/${educationalInfo.id}`,
    fd
  );
  return response.data;
};
// Update staff educational Information
const updateStaffEmploymentInfo = async (educationalInfo) => {
  const response = await axiosPrivate.post(
    `${UPDATE_STAFF_EMI}/${educationalInfo.id}`,
    educationalInfo
  );
  return response.data;
};
// Update staff next of kin Information
const updateStaffNextOfKinInfo = async (nextOfKinInfo) => {
  const response = await axiosPrivate.post(
    `${UPDATE_STAFF_NKI}/${nextOfKinInfo.id}`,
    nextOfKinInfo
  );
  return response.data;
};
// Update staff previous work Information
const updateStaffPreviousWorkInfo = async (previousWorkInfo) => {
  const response = await axiosPrivate.post(
    `${UPDATE_STAFF_WI}/${previousWorkInfo.id}`,
    previousWorkInfo
  );
  return response.data;
};
//  Update staff guarantor Information
const updateStaffGuarantorInfo = async (guarantorInfo) => {
  let formdata = { ...guarantorInfo };
  delete formdata["temp_url"];
  const fd = new FormData();
  // fd.append('_method', 'POST')
  let data = getObjectEntries(formdata);
  data.forEach(([key, value]) => {
    fd.append(key, value);
  });
  // // fd.append
  const response = await axiosPrivate.post(
    `${UPDATE_STAFF_GI}/${guarantorInfo.id}`,
    fd
  );
  return response.data;
};

const activateStaff = async ({ id }) => {
  const response = await axiosPrivate.get(`${ACTIVATE_STAFF}/${id}`);
  return response.data;
};

const deactivateStaff = async ({ id }) => {
  const response = await axiosPrivate.get(`${DEACTIVATE_STAFF}/${id}`);
  return response.data;
};

const staffService = {
  fetchAllStates,
  getAppStatus,
  addStaffPersonalInfo,
  addStaffContactInfo,
  addStaffEducationalInfo,
  removeStaffEducationalInfo,
  addStaffEmploymentInfo,
  addStaffGuarantorInfo,
  addStaffWorkExperience,
  addStaffNextOfKinInfo,
  makeStaffUser,
  getAllStaffs,
  getAllRoles,
  getStaffInformation,
  updateStaffPersonalInfo,
  updateStaffContactInfo,
  updateStaffEducationalInfo,
  updateStaffEmploymentInfo,
  updateStaffNextOfKinInfo,
  updateStaffPreviousWorkInfo,
  updateStaffGuarantorInfo,
  activateStaff,
  deactivateStaff,
};

export default staffService;
